import { useMutation } from "@tanstack/react-query";
import { trainerAccountApi } from "api/trainers/trainerAccountApi";

export const useUnlinkTrainerAccount = (trainerId: number) => {
  return useMutation({
    mutationFn: () => trainerAccountApi.unlinkAccount(trainerId),
  });
};
